export default {
  HTTP_ERROR_CODE: 500,
  HTTP_NOT_FOUND: 404,
  // 响应状态
  Status: {
    USER_EXISTS: {
      code: '010000',
      message: '用户已存在'
    },
    USER_NOT_EXISTS: {
      code: '010001',
      message: '用户不存在'
    },
    SUCCESS: {
      code: 'SUCCESS',
      message: '请求处理成功'
    },
    INVALID_URI: {
      code: 'INVALID_URI',
      message: '无效的授权地址'
    },
    ERROR: {
      code: 'ERROR',
      message: '系统繁忙，请稍后再试'
    }
  }
}
